import {touch2Mouse, addTouchEvents} from "libs/jquery-metroUi/js/metro-touch-handler.js";
window.touch2Mouse = touch2Mouse;
window.addTouchEvents = addTouchEvents;
require('libs/jquery-metroUi/js/metro-core.js');
require('libs/jquery-metroUi/js/metro-locale.js');
require('libs/jquery-metroUi/js/metro-accordion.js');
require('libs/jquery-metroUi/js/metro-button-set.js');
require('libs/jquery-metroUi/js/metro-date-format.js');
require('libs/jquery-metroUi/js/metro-calendar.js');
require('libs/jquery-metroUi/js/metro-datepicker.js');
require('libs/jquery-metroUi/js/metro-carousel.js');
require('libs/jquery-metroUi/js/metro-countdown.js');
require('libs/jquery-metroUi/js/metro-dropdown.js');
require('libs/jquery-metroUi/js/metro-input-control.js');
require('libs/jquery-metroUi/js/metro-live-tile.js');
require('libs/jquery-metroUi/js/metro-drag-tile.js');
require('libs/jquery-metroUi/js/metro-progressbar.js');
require('libs/jquery-metroUi/js/metro-rating.js');
require('libs/jquery-metroUi/js/metro-slider.js');
require('libs/jquery-metroUi/js/metro-tab-control.js');
require('libs/jquery-metroUi/js/metro-table.js');
require('libs/jquery-metroUi/js/metro-times.js');
require('libs/jquery-metroUi/js/metro-dialog.js');
require('libs/jquery-metroUi/js/metro-notify.js');
require('libs/jquery-metroUi/js/metro-listview.js');
require('libs/jquery-metroUi/js/metro-treeview.js');
require('libs/jquery-metroUi/js/metro-fluentmenu.js');
require('libs/jquery-metroUi/js/metro-hint2.js');
require('libs/jquery-metroUi/js/metro-streamer.js');
require('libs/jquery-metroUi/js/metro-scroll.js');
require('libs/jquery-metroUi/js/metro-stepper.js');
require('libs/jquery-metroUi/js/metro-pull.js');
require('libs/jquery-metroUi/js/metro-wizard.js');
require('libs/jquery-metroUi/js/metro-panel.js');
require('libs/jquery-metroUi/js/metro-tile-transform.js');
require('libs/jquery-metroUi/js/metro-popover.js');
require('libs/jquery-metroUi/js/metro-initiator.js');

$.Notify.error = function (message, title) {
    return $.Notify({
        content: message,
        style: {
            background: '#faa',
            color: '#fff',
        },
        caption: title
    });
};

$.Notify.warn = function (message, title) {
    return $.Notify({
        content: message,
        style: {
            background: '#fcf8e3',
            color: '#8a6d3b',
        },
        caption: title
    });
};